import { useState, useEffect, useContext } from "react";
import axios from "../../Axios";
import { Urls } from "../../Urls";
import Loader from "../Loader";
import classes from "./indenttrack.module.css";
import ViewEnquiry from "../Chat/chat";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import "react-accessible-accordion/dist/fancy-example.css";
import Modal from "../Shared/PopupModal/PopupModal";
import { toast } from "react-toastify";
import { Activity, currentRequestTimeStamp, isMobile } from "../../Constants";
import { TRACKING_DETAILS_URL } from '../../Urls';
import ReactTooltip from "react-tooltip";
import Timeline from "./Timeline/Timeline";
import Pagination from "react-js-pagination";
import ProfileModal from "../TransporterClientScreen/ProfileModal/ProfileModal";
import Select from "react-select/creatable";
import { checkIndentAccess, titleCase } from "../../Utility";
import { mailerAPI } from "../Freightrates1/Utility";
import { DownloadIndentReports } from "./DownloadReport/IndentReport";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { EditableEmailsContext } from "../../Context/EditableEmailsContext";
import UploadPOD from "./components/indentTracking/UploadPOD";
import MultiSelectFilterUI from "../Shared/newfilterui/MultiSelectFilterUI";
import ExcelFileTable from "./components/indentTracking/ExcelFileTable";
import ViewDetails from "./components/indentTracking/ViewDetails";
import CancelIndent from "./components/indentTracking/CancelIndent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useIndentTracking } from "./hooks/useIndentTracking";
import { checkModuleAccess } from "../../Utility";
import DownloadIndentDocuments from "./DownloadReport/DownloadIndentDocuments";
import TransportType from "./Transporttype";
import Popupwidget from "../Shared/PopupModal/PopupModal";
import useViewOnlyAccess from "../../hooks/useViewOnlyAccess";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";


const Indenttrack = ({
  // closechatModal,
  // getIndents,
  show,
  setshow,
  // filtered_details,
  // setfiltered_details,
  // details,
  setdetails,
}) => {
  // var user_name =
  //   localStorage.getItem("userdetails") +
  //   "-" +
  //   localStorage.getItem("useremail");
  // const [valueselected, setValueselected] = useState("")
  const [lastupdatelist, setLastupdatelist] = useState([]);
  const [actionMenuOpen, setActionMenuOpen] = useState(null);
  const history = useHistory();

  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [filtersshown, setfiltershown] = useState(false);


  const DEFAULT_SORT_OPTIONS = [
    { value: "created_date", label: "Created Date" },
  ];

  const [showloader, setShowloader] = useState(false);
  const [skipactive, setSkipactive] = useState(0);
  const [totalindents, setTotalindents] = useState(0);
  const [ExcelDownloadIndents, setExcelDownloadIndents] = useState([]);
  var company_mail = localStorage.getItem("useremail");
  const [userview, setuserview] = useState(true);
  // let history = useHistory();
  const [allowed_view_indent, setallowed_view_indent] = useState(false);
  // const [emailTemplate, setemailTemplate] = useState({
  //   reminderFromCompany: "",
  //   reminderCCCompany: [],
  //   reminderContentCompany: "",
  //   reminderSubjectCompany: "",
  //   reminderFromTransporter: "",
  //   reminderCCTransporter: [],
  //   reminderContentTransporter: "",
  //   reminderSubjectTransporter: "",
  // });
  const [notifyEmail, setNotifyEmail] = useState({
    notifyFrom: "",
    notifyCC: [],
    notifyContent: "",
    notifySubject: "",
  });
  const [indentBucket, setIndentBucket] = useState("active");
  const [indentLevel, setIndentLevel] = useState("user_view");
  const { userDetails, companyProfile } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [isAccountant, setIsAccountant] = useState(false);

  const emailData = useContext(EditableEmailsContext);

  const { trackIndentEvent } = useIndentTracking();
  const { isRestricted, canAccessReports } = useViewOnlyAccess(
    "indent",
    "lorri_indent_tracking",
    true,
  );

  const getColor = (isAvailable) => (isAvailable ? "#54a63a" : "red");

  useEffect(() => {
    // Fetch vehicle tracking data with parameters: start index (0), limit (10), and view ("user_view")
    getVehicleTracking(0, 10, 0, "user_view");

    // Set the document title for the current page
    document.title = "LoRRI - Indent Tracking";

    // Check if user details are available and if a policy type is set
    if (userDetails?.policy?.type) {
      // Determine if the user is allowed to view the indent tracking based on policy details
      setallowed_view_indent(
        userDetails?.policy?.indents &&
          userDetails?.policy?.indents?.allowed === "yes" &&
          userDetails?.policy?.indents?.allowed_view_company_indent === "yes"
          ? true
          : false,
      );
    }

    // Set the show state to false
    setshow(false);

    // If email data is available, set the notification email details
    if (emailData) {
      setNotifyEmail({
        notifyFrom: emailData?.indentTrackMail?.from,
        notifyCC: emailData?.indentTrackMail?.cc,
        notifyContent: emailData?.indentTrackMail?.content,
        notifySubject: emailData?.indentTrackMail?.subject,
      });
    }

    // Dependencies: Effect runs whenever userDetails changes
    if (companyProfile && userDetails) {
      const companyId = companyProfile?.domain_data?.company_id;

      if (companyId) {
        const getAccountantData = async () => {
          try {
            const res = await axios.get(
              `${Urls.companyProfile}?company_id=${companyId}&projections_enable=contact_information`,
            );

            const users = res?.data?.[0]?.contact_information ?? [];

            const isAccountant = users.some(
              (user) =>
                user?.email?.trim().toLowerCase() ===
                userDetails?.email?.trim().toLowerCase() &&
                user?.team?.trim().toLowerCase() === "accounts",
            );

            setIsAccountant(isAccountant);
          } catch (err) {
            console.log(err);
          }
        };

        getAccountantData();
      }
    }
  }, [userDetails, emailData, companyProfile]);

  /**
   * Fetches vehicle tracking data from the server and updates state based on the response.
   * @param {number} skipval - The number of records to skip (used for pagination).
   * @param {number} limit - The maximum number of records to fetch.
   * @param {number} skip - The number of records to skip based on current pagination.
   * @param {string} [view] - Optional view parameter that determines the type of view ("company_view" or "user_view").
   * @returns {void}
   */
  const getVehicleTracking = (skipval, limit, skip, view, forceReset = false) => {
    // Show loading indicator
    setshow(true);
    setShowloader(true);
    // Set the current skip value for pagination
    setSkipactive(skipval);

    const activeView = view || (userview ? "user_view" : "company_view");

    let payload = {
      filters: [],
      filtersOperator: "and",
      search: "",
      view: activeView,
      pagination: {
        skip: skipval > 0 ? skip : 0,
        limit: limit
      },
      sort: {
        key: "created_date",
        order: "desc"
      }
    };

    if (!forceReset && isFilterActive && filterPayload) {
      payload = {
        ...filterPayload,
        view: activeView,
        pagination: { skip: skipval > 0 ? skip : 0, limit: limit },
      };
    }

    axios
      .post(`${Urls.indent}?field=get_vehicle_tracks_v2`, payload)
      .then((res) => {
        setTotalindents(res.data.total_indents);
        setshow(false);
        setShowloader(false);
        setLastupdatelist(res.data.vehicle_tracks);
        reload_data(res.data.vehicle_tracks);
      })
      .catch((e) => {
        setshow(false);
        setShowloader(false);
        console.log(e);
      });
  };

  const getData = () => {
    const activeLimit = filterPayload?.pagination?.limit || 10;
    isFilterActive && filterPayload ? handleFilterApply(filterPayload, false) : getVehicleTracking(skipactive, activeLimit, skipactive * activeLimit, userview ? "user_view" : "company_view")
  };

  const handleFilterApply = (payload, showToast = true) => {
    setIsFilterLoading(true);
    setIsFilterActive(true);
    setfiltershown(false);

    if (payload.company_id) delete payload.company_id;
    if (payload.date_range) delete payload.date_range;
    if (payload.filter_opertaion) delete payload.filter_opertaion;
    if (payload.bucket) delete payload.bucket;
    if (payload.filtersOperator) {
      payload.filtersOperator = "and"; // Standardize to 'and' for tracking
    }

    if (payload?.pagination?.skip === 0) {
      setSkipactive(0);
    }

    // Ensure we keep the active view and synchronize the state
    if (payload.view) {
      setuserview(payload.view === "user_view");
      setIndentLevel(payload.view);
    } else {
      payload.view = userview ? "user_view" : "company_view";
    }

    setFilterPayload(payload);
    setshow(true);

    axios.post(`${Urls.indent}?field=get_vehicle_tracks_v2`, payload)
      .then((res) => {
        setTotalindents(res.data.total_indents);
        setshow(false);
        setIsFilterLoading(false);
        setLastupdatelist(res.data.vehicle_tracks);
        reload_data(res.data.vehicle_tracks);
        if (showToast) {
          toast.success(`Found ${res.data.total_indents} results`);
        }
      })
      .catch((err) => {
        console.log(err);
        setshow(false);
        setIsFilterLoading(false);
        toast.error("Failed to apply filters");
      });
  };

  const handleFilterReset = () => {
    setIsFilterActive(false);
    setFilterPayload(null);
    setSkipactive(0);
    setfiltershown(false);
    setuserview(true);
    setIndentLevel("user_view");
    getVehicleTracking(0, 10, 0, "user_view", true);
    toast.info("Filters reset");
  };

  const getOnChange = (e) => {
    const activeLimit = filterPayload?.pagination?.limit || 10;
    setSkipactive(e - 1);
    const newSkip = (e - 1) * activeLimit;

    if (isFilterActive && filterPayload) {
      const updatedPayload = {
        ...filterPayload,
        pagination: { ...filterPayload.pagination, skip: newSkip, limit: activeLimit }
      };
      setFilterPayload(updatedPayload);
      handleFilterApply(updatedPayload, false);
    } else {
      getVehicleTracking(e - 1, activeLimit, newSkip, userview ? "user_view" : "company_view");
    }
  };

  const getFilterCount = () => {
    let count = 0;
    if (isFilterActive && filterPayload) {
      count += filterPayload.filters?.length || 0;
      if (filterPayload.search && filterPayload.search.trim() !== "") count++;
    }
    if (indentLevel !== "user_view") count++;
    return count;
  };

  const ActiveFilterPills = () => {
    if (!isFilterActive || !filterPayload) return null;

    const hasFilters = filterPayload.filters && filterPayload.filters.length > 0;
    const hasSearch = filterPayload.search && filterPayload.search.trim() !== "";

    const currentSortKey = filterPayload.sort?.key;
    const isDefaultSort = currentSortKey === "created_date" || !currentSortKey;
    const currentSortLabel =
      DEFAULT_SORT_OPTIONS.find((o) => o.value === currentSortKey)?.label ||
      currentSortKey;
    const hasSort = !isDefaultSort;

    const currentLimit = filterPayload.pagination?.limit;
    const hasPagination = currentLimit && currentLimit !== 10;

    const hasView = filterPayload.view && filterPayload.view !== "user_view";

    if (!hasFilters && !hasSearch && !hasSort && !hasPagination && !hasView)
      return null;

    const removeFilter = (filterKey) => {
      const updatedFilters = filterPayload.filters.filter(
        (f) => f.key !== filterKey
      );
      if (
        updatedFilters.length === 0 &&
        (!filterPayload.search || filterPayload.search.trim() === "") &&
        !hasSort &&
        !hasPagination
      ) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          filters: updatedFilters,
          pagination: { ...filterPayload.pagination, skip: 0 },
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const clearSearch = () => {
      const updatedPayload = { ...filterPayload, search: "" };
      if (
        (!updatedPayload.filters || updatedPayload.filters.length === 0) &&
        !hasSort &&
        !hasPagination
      ) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          search: "",
          pagination: { ...filterPayload.pagination, skip: 0 },
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const resetSort = () => {
      const updatedPayload = {
        ...filterPayload,
        sort: { key: "created_date", order: "desc" },
      };
      if (!hasFilters && !hasSearch && !hasPagination) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          sort: { key: "created_date", order: "desc" },
          pagination: { ...filterPayload.pagination, skip: 0 },
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const resetPagination = () => {
      const updatedPayload = {
        ...filterPayload,
        pagination: { ...filterPayload.pagination, limit: 10 },
      };
      if (!hasFilters && !hasSearch && !hasSort) {
        handleFilterReset();
      } else {
        const updatedPayloadComplete = {
          ...filterPayload,
          pagination: { ...filterPayload.pagination, limit: 10, skip: 0 },
        };
        setFilterPayload(updatedPayloadComplete);
        handleFilterApply(updatedPayloadComplete);
      }
    };

    const resetView = () => {
      const updatedPayload = {
        ...filterPayload,
        view: "user_view",
        pagination: { ...filterPayload.pagination, skip: 0 },
      };
      setuserview(true);
      setIndentLevel("user_view");
      if (!hasFilters && !hasSearch && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const formatValue = (value) => {
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      return value;
    };

    return (
      <div className={classes.activeFiltersArea}>
        <div className={classes.filterHeader}>
          <i className="fa fa-filter mr-2 text-primary" />
          <span className={classes.filterHeaderLabel}>Active Filters</span>
        </div>

        <div className={classes.filterPillsContainer}>
          {filterPayload.view && filterPayload.view !== "user_view" && (
            <div className={classes.filterPill}>
              <span className={classes.filterPillContent}>
                <i
                  className="fa fa-eye mr-1 text-primary"
                  style={{ fontSize: "10px" }}
                />
                <strong className={classes.filterPillTitle}>View:</strong>{" "}
                {filterPayload.view === "user_view"
                  ? "My Indents"
                  : "Company Indents"}
              </span>
              {filterPayload.view !== "user_view" && (
                <i
                  className={`fa fa-times ${classes.filterRemoveBtn}`}
                  onClick={resetView}
                />
              )}
            </div>
          )}
          {hasSearch && (
            <div className={classes.filterPill}>
              <span className={classes.filterPillContent}>
                <i className="fa fa-search mr-1 text-info" style={{ fontSize: "10px" }} />
                <strong className={classes.filterPillTitle}>Search:</strong> {filterPayload.search}
              </span>
              <i className={`fa fa-times ${classes.filterRemoveBtn}`} onClick={clearSearch} />
            </div>
          )}

          {filterPayload.filters?.map((f, i) => (
            <div key={`${f.key}_${i}`} className={classes.filterPill}>
              <span className={classes.filterPillContent}>
                <i className="fa fa-check-circle mr-1 text-success" style={{ fontSize: "10px" }} />
                <strong className={classes.filterPillTitle}>{f.label || f.key}:</strong> {formatValue(f.values)}
              </span>
              <i className={`fa fa-times ${classes.filterRemoveBtn}`} onClick={() => removeFilter(f.key)} />
            </div>
          ))}

          {hasSort && (
            <div className={classes.filterPill}>
              <span className={classes.filterPillContent}>
                <i className="fa fa-sort mr-1 text-warning" style={{ fontSize: "10px" }} />
                <strong className={classes.filterPillTitle}>Sort:</strong> {currentSortLabel}
              </span>
              <i className={`fa fa-times ${classes.filterRemoveBtn}`} onClick={resetSort} />
            </div>
          )}

          {hasPagination && (
            <div className={classes.filterPill}>
              <span className={classes.filterPillContent}>
                <i className="fa fa-list-ol mr-1 text-purple" style={{ fontSize: "10px" }} />
                <strong className={classes.filterPillTitle}>Limit:</strong> {currentLimit}
              </span>
              <i className={`fa fa-times ${classes.filterRemoveBtn}`} onClick={resetPagination} />
            </div>
          )}
        </div>

        <button
          className={classes.clearAllBtn}
          onClick={handleFilterReset}
        >
          Clear All
        </button>
      </div>
    );
  };

  // const changeHandler = (e, transporter_id, indent_id, indent_id_sub) =>{
  //     Activity([{ "screen": "Indents", "module": "Vehicle Tracking", "user_activity": `Indent status changed for ${indent_id_sub} as ${e.value}`, "timestamp": currentRequestTimeStamp() }])
  //     setShowloader(true)
  //     if(window.confirm('Are you sure to update')){
  //         setShowloader(true)
  //         axios.put(`${Urls.indent}?transporter_id=${transporter_id}&indent_id=${indent_id}&field=status_track_update&indent_id_sub=${indent_id_sub}`, {'value':e.value}).then(res=>{
  //             toast.success('Status Updated')
  //             getIndents()
  //             setShowloader(false)
  //         }).catch(e=>{
  //             console.log(e)
  //         })
  //     }
  //      else{
  //         setShowloader(false)
  //     }
  // }

  // const DateFormatter1 = (inputdate) => {
  //     if( inputdate !== undefined && inputdate !== '' && inputdate !== null){
  //         var date = new Date(inputdate);
  //         var year = date.getFullYear();
  //         var month = date.getMonth() + 1;
  //         var dt = date.getDate();
  //         var time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  //         if (dt < 10) {
  //             dt = '0' + dt;
  //         }
  //         if (month < 10) {
  //             month = '0' + month;
  //         }
  //         return (
  //             <>
  //                 <span style={{fontSize:'11px', fontStyle:'italic'}}>{dt + '/' + month + '/' + year}</span><br/>
  //                 <span style={{fontSize:'11px', fontStyle:'italic'}}>{time}</span>
  //             </>
  //         )
  //     } else{
  //         return <span></span>
  //     }
  // }

  // const DateFormatter = (inputdate) => {
  //     if( inputdate !== undefined && inputdate !== '' && inputdate !== null){
  //         var date = new Date(inputdate);
  //         var year = date.getFullYear();
  //         var month = date.getMonth() + 1;
  //         var dt = date.getDate();
  //         if (dt < 10) {
  //             dt = '0' + dt;
  //         }
  //         if (month < 10) {
  //             month = '0' + month;
  //         }
  //         return (
  //             <>
  //                 <span>{dt + '/' + month + '/' + year}</span>
  //             </>
  //         )
  //     } else{
  //         return <span></span>
  //     }
  // }

  // const getIndents = () => {
  //     setshow(true)
  //     // var messages = []
  //     axios.get(`${Urls.allindents}`)
  //         .then(res => {
  //             axios.get(`${Urls.indent_chat}&email=${company_mail}`)
  //                 .then(r => {
  //                     var indents = res.data.map((i) => {
  //                         r.data.map((ml) => {
  //                             var no_of_enq = 0
  //                             if (i.indent_id === ml.indent_id) {
  //                                 ml.message_list.map((msg) => {
  //                                     if (msg.transporter_unread_count) {
  //                                         no_of_enq = no_of_enq + msg.transporter_unread_count
  //                                     }
  //                                 })
  //                                 i.noofenq = no_of_enq
  //                             }
  //                         })
  //                         // i.is_deleted = false
  //                         return i
  //                     })
  //                     setdetails(indents)
  //                     setfiltered_details(indents)
  //                     setshow(false)
  //                 }).catch(e =>{
  //                     setshow(false)
  //                     console.log(e)
  //             })
  //         })
  //         .catch(err => {
  //             console.log(err)
  //             setshow(false)
  //         })
  // }

  //closes chat modal by using ID
  const closechatModal = () => {
    reload_data(lastupdatelist);
  };
  /**
   * Determines the CSS class for a given status.
   * @param {string} status - The status for which the CSS class is determined.
   * @returns {string} - The CSS class corresponding to the provided status.
   */
  const getStatusStyle = (status) => {
    if (status === "clarity_needed") {
      return classes["mismatch"]; // CSS class for mismatch status
    }
    if (status === "pending" || status === "not_generated") {
      return classes["pending"]; // CSS class for pending or not generated status
    }
    if (status === "onhold") {
      return classes["onhold"]; // CSS class for on hold status
    }
    if (status === "approved") {
      return classes["success"]; // CSS class for approved status
    }
  };

  /**
   * Reloads data by updating indents with unread message counts.
   * Fetches new data based on the indent IDs and updates the state.
   * @param {Array} data - The array of data objects to process.
   * @returns {void}
   */
  const reload_data = (data) => {
    // var enq = streamingdata.slice() // Uncomment if needed for further processing
    // var messages = [] // Uncomment if needed for message tracking

    if (data.length > 0) {
      var indent_id = []; // Array to store unique indent IDs
      for (var i = 0; i < data.length; i++) {
        if (!indent_id.includes(data[i].indent_id)) {
          indent_id.push(data[i].indent_id); // Collect unique indent IDs
        }
        if (i === data.length - 1) {
          var payload = { shard_ids: data.length > 0 ? indent_id : [] };
          axios
            .post(
              `${Urls.indent_chat}&email=${company_mail}&id_specific=true`,
              payload,
            )
            .then((r) => {
              var indents = data.map((i) => {
                r.data.map((ml) => {
                  // var no_of_enq = 0
                  if (i.indent_id === ml.indent_id) {
                    // ml.message_list.map((msg) => {
                    //     if (msg.transporter_unread_count) {
                    //         no_of_enq = no_of_enq + msg.transporter_unread_count
                    //     }
                    // })
                    // i.noofenq = no_of_enq // Uncomment if needed for unread message count
                    i.no_of_enq = ml.transporter_unread_count; // Update unread count
                  }
                  return null;
                });
                return i;
              });
              // setshow(false)
              setdetails(indents); // Update state with new indent data
              setLastupdatelist(indents); // Update last update list
            })
            .catch((e) => {
              setshow(false); // Hide loader on error
              console.log(e); // Log error
            });
        }
      }
    }
    // setshow(true)
  };

  /**
   * Checks if a specific type of file upload is present in the vehicle's file uploads and returns a corresponding color code.
   * @param {Object} indent - The indent object containing vehicle information.
   * @param {string} type - The type of file to check for in the vehicle's file uploads.
   * @returns {string} - Returns a color code based on the presence of the file type:
   *                     - "#54a63a" if the file type is found.
   *                     - "red" if the file type is not found or if there are no file uploads.
   */
  const checkPresent = (indent, type) => {
    if (indent.vehicle.file_uploads && indent.vehicle.file_uploads.length > 0) {
      for (var i = 0; i < indent.vehicle.file_uploads.length; i++) {
        if (
          indent.vehicle.file_uploads[i].type === type &&
          indent.vehicle.file_uploads[i].is_deleted !== true
        ) {
          return "#54a63a"; // Return green color code if the file type is found
        }
      }
      return "red"; // Return red color code if the file type is not found
    }
    return "red"; // Return red color code if there are no file uploads
  };

  /**
   * Checks if a specific type of invoice file upload is present in the vehicle's file uploads and returns a status string.
   * @param {Object} indent - The indent object containing vehicle information.
   * @param {string} type - The type of file to check for in the vehicle's file uploads.
   * @returns {string} - Returns a status string based on the presence of the file type:
   *                     - "uploaded_invoice" if the file type is found.
   *                     - "not_uploaded_invoice" if the file type is not found or if there are no file uploads.
   */
  const checkPresentInvoice = (indent, type) => {
    if (indent.vehicle.file_uploads && indent.vehicle.file_uploads.length > 0) {
      for (var i = 0; i < indent.vehicle.file_uploads.length; i++) {
        if (
          indent.vehicle.file_uploads[i].type === type &&
          indent.vehicle.file_uploads[i].is_deleted !== true
        ) {
          return "uploaded_invoice"; // Return status if the invoice file type is found
        }
      }
      return "not_uploaded_invoice"; // Return status if the invoice file type is not found
    }
    return "not_uploaded_invoice"; // Return status if there are no file uploads
  };

  /**
   * Checks if a specific type of POD file upload is present in the vehicle's file uploads and returns a status string.
   * @param {Object} indent - The indent object containing vehicle information.
   * @param {string} type - The type of file to check for in the vehicle's file uploads.
   * @returns {string} - Returns a status string based on the presence of the file type:
   *                     - "uploaded_pod" if the file type is found.
   *                     - "not_uploaded_pod" if the file type is not found or if there are no file uploads.
   */
  const checkPresentPOD = (indent, type) => {
    if (indent.vehicle.file_uploads && indent.vehicle.file_uploads.length > 0) {
      for (var i = 0; i < indent.vehicle.file_uploads.length; i++) {
        if (
          indent.vehicle.file_uploads[i].type === type &&
          indent.vehicle.file_uploads[i].is_deleted !== true
        ) {
          return "uploaded_pod"; // Return status if the POD file type is found
        }
      }
      return "not_uploaded_pod"; // Return status if the POD file type is not found
    }
    return "not_uploaded_pod"; // Return status if there are no file uploads
  };


  // const getAllIndents = () => {
  //     Activity([{ "screen": "Indents", "module": "Indent request", "user_activity": `Download Excel Button Clicked`, "timestamp": currentRequestTimeStamp() }])
  //     setshow(true)
  //     // axios.get(`${Urls.allindents}`)
  //     axios.get(`${Urls.allindents}&${userview === true ? 'view=user_view' : 'view=company_view'}`)
  //         .then(res => {
  //             var updatedlist = []
  //             if(res.data && res.data.length > 0){
  //                 res.data.map((indent)=>{
  //                     var podlist = []
  //                     var invoicelist = []
  //                     if(indent.vehicle_tracking && indent.vehicle_tracking.length > 0 ){
  //                         indent.vehicle_tracking.map((indent_sub)=>{
  //                             var newindentitem = {
  //                                 user_id: indent.user_id,
  //                                 indent_id: indent.indent_id,
  //                                 display_indent_id: indent.display_indent_id,
  //                                 indent_id_sub: indent_sub.indent_id_sub,
  //                                 created_date: indent.created_date,
  //                                 user_list: indent.user_list,
  //                                 origin: indent.indent_info.origin,
  //                                 destination: indent.indent_info.destination,
  //                                 truck_types: indent.indent_info.truck_types,
  //                                 placement_date: indent.indent_info.placement_date,
  //                                 transporter_id: indent_sub.transporter_id,
  //                                 transporter_name: indent_sub.transporter_name,
  //                                 shortlisted_transporters: indent.indent_info.shortlisted_transporters,
  //                                 truck_details: indent_sub.truck_details,
  //                                 status_track: indent_sub.status_track,
  //                                 pod: indent_sub.file_uploads.filter((pods) => pods.type === "pod"),
  //                                 invoice: indent_sub.file_uploads.filter((invoice) => invoice.type === "invoice"),
  //                                 from: indent.indent_info.from
  //                             }
  //                             updatedlist.push(newindentitem)
  //                             return newindentitem
  //                         })
  //                     }
  //                     return null
  //                 })
  //             }
  //             setExcelDownloadIndents(updatedlist)
  //             document.getElementById('test-table-xls-button').click()
  //             setshow(false)
  //             setExcelDownloadIndents([])
  //         })
  //         .catch(err => {
  //             console.log(err)
  //             setshow(false)
  //         })
  // }

  // const get_unloaded = (status_track) => {
  //     for(var i = 0; i < status_track.length; i++  ){
  //         if (status_track[i].value === 'unloaded'){
  //             return false
  //         }
  //     }
  //     return true
  // } 

  //Send Mail Function
  const sendMail1 = (item, types) => {
    trackIndentEvent(
      "indent tracking",
      "user has clicked on send reminder email button",
      `${types === "lr" ? "LR" : "Invoice"} reminder email sent to transporter, indent id sub: ${item.vehicle.indent_id_sub}`,
    );

    var company_name = item?.company_name;
    var generateFor =
      types === "lr" ? "LR" : types === "pod" ? "POD" : "Invoice";
    var finalSubject =
      types === "lr"
        ? "Generate LR @LoRRI"
        : types === "pod"
          ? "Upload POD @LoRRI"
          : "Generate Invoice @LoRRI";
    var matchedTransporter;
    if (item && item?.transporter_data) {
      const access_control = item?.transporter_data?.access_control;
      const contact_information = item?.transporter_data?.contact_information;
      const pocList =
        access_control && access_control?.length > 0
          ? access_control
          : (contact_information || []).filter(
            (poc) => String(poc?.poc).toLowerCase() === "yes",
          );

      pocList.map((poc) => {
        if (
          access_control && access_control.length > 0
            ? checkIndentAccess(poc, "Indent") &&
            checkModuleAccess(
              access_control,
              poc?.contact_number,
              "Indent",
              company_name,
            )
            : true
        ) {
          var transporter_name = poc.name;
          var localtableTransporter = `<table border="1">
                                                <thead>
                                                    <th>
                                                    Sr. No.
                                                    </th>
                                                      <th>
                                                        Indent ID
                                                      </th>
                                                    <th>
                                                    Origin
                                                    </th>
                                                    <th>
                                                    Destination
                                                    </th>
                                                    <th>
                                                    Truck Type
                                                    </th>
                                                    <th>
                                                    Date of Placement/ Contract
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>${item.vehicle
              .indent_id_sub
            }</td>
                                                        <td>${item.indent_info
              .origin
              .location_name
            }</td>
                                                        <td>${item.indent_info
              .destination
              .location_name
            }</td>
                                                        <td> ${Array.isArray(
              item.indent_info
                .truck_types,
            )
              ? item.indent_info.truck_types.map(
                (tt) => {
                  return tt.value;
                },
              )
              : item.indent_info
                .truck_types
                .label
            }
                                                        <td>
                                                        ${item.indent_info
              .placement_date
            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>`;
          var emailBody = {
            activity: "Email Request",
            type: "superlaunch",
            mail_status: "Pending",
            from_email: notifyEmail.notifyFrom,
            user_type: "transporter",
            cc: notifyEmail.notifyCC,
            subject: finalSubject,
            to_email: `${poc.email}`,
            Application_name: "lorri",
            module_name: "Indents",
            timestamp: currentRequestTimeStamp(),
            subject: eval("`" + notifyEmail.notifySubject + "`"),
            content: eval("`" + notifyEmail.notifyContent + "`"),
          };
          // console.log("calling mailer api")
          mailerAPI(emailBody, setshow);
        }
        return null;
      });
    }
    toast.success("Reminder Sent Successfully!");
  };

  return (
    <div style={{ width: "100%", paddingTop: "2%" }}>
      <Loader show={show || showloader} />
      <div className="d-flex w-100 justify-content-between align-items-center mb-2 px-3">
        <div className={`d-flex align-items-center ${classes.gap15}`}>
          <button
            className={`btn btn-sm btn-primary tr-button1 ${classes.filterBtn}`}
            onClick={() => setfiltershown(!filtersshown)}
            title={isFilterActive ? "Filters are active" : "Advanced Filters"}
          >
            <i className="fas fa-filter" style={{ color: "white" }} />
            Filter {getFilterCount() > 0 ? `(${getFilterCount()})` : ""}
          </button>

          {allowed_view_indent && (
            <select
              className={`form-control ${classes.viewSelect}`}
              value={indentLevel}
              onChange={(e) => {
                const newLevel = e.target.value;
                setIndentLevel(newLevel);
                setuserview(newLevel === "user_view" ? true : false);
                setIsFilterActive(true);
                const updatedPayload = {
                  ...(filterPayload || {
                    filters: [],
                    search: "",
                    sort: { key: "created_date", order: "desc" },
                    pagination: { skip: 0, limit: 10 }
                  }),
                  view: newLevel
                };
                setFilterPayload(updatedPayload);
                handleFilterApply(updatedPayload, false);
              }}
            >
              <option value="user_view">My Indents</option>
              <option value="company_view">Company Indents</option>
            </select>
          )}
        </div>

        <div
          className={`d-button3 d-flex align-items-center mb-0 ${classes.gap10}`}
        >
          <button
            className={`btn btn-sm btn-outline-primary ${classes.refreshButton}`}
            onClick={() => {
              if (isFilterActive && filterPayload) {
                handleFilterApply(filterPayload, false);
              } else {
                getVehicleTracking(skipactive, 10, skipactive * 10, indentLevel);
              }
            }}
            title="Refresh Data"
          >
            <i className="fas fa-sync-alt" />
          </button>

          <div
            onClick={() =>
              !canAccessReports &&
              toast.info("You don't have permission to perform this action.")
            }
            style={{
              display: "inline-block",
              cursor: !canAccessReports ? "not-allowed" : "pointer",
            }}
          >
            <Modal
              style={{
                ...(canAccessReports
                  ? {}
                  : { cursor: "not-allowed", opacity: 0.6, pointerEvents: "none" }),
              }}
              buttonLabel={`Download LR, POD & Invoice`}
              buttonClass="btn btn-sm btn-primary"
              content={<DownloadIndentDocuments />}
              title={`Download LR, POD & Invoice`}
              id="closebutton"
              screenName="LoRRI Indent"
              moduleName="Indent Request"
              activityName={`Download LR, POD & Invoice`}
              backdrop={false}
              disabled={!canAccessReports}
            />
          </div>
          <div
            onClick={() =>
              !canAccessReports &&
              toast.info("You don't have permission to perform this action.")
            }
            style={{
              display: "inline-block",
              cursor: !canAccessReports ? "not-allowed" : "pointer",
            }}
          >
            <Modal
              style={{
                ...(canAccessReports
                  ? {}
                  : { cursor: "not-allowed", opacity: 0.6, pointerEvents: "none" }), // Conditional styles
                margin: isMobile() ? "2% -5%" : " ",
              }}
              buttonLabel={`Download Report`}
              buttonClass="btn btn-sm btn-primary"
              content={
                <DownloadIndentReports
                  days={15}
                  bucket={indentBucket}
                  level={indentLevel}
                  indent_type="indent_track"
                />
              }
              title={`Report Generator`}
              id="closebutton"
              screenName="LoRRI Indent"
              moduleName="Indent Request"
              activityName={`Download Report`}
              backdrop={false}
              disabled={!canAccessReports}
            />
          </div>
        </div>
      </div>
      {filtersshown && (
        <div className="mt-2 mb-4 mx-3">
          <MultiSelectFilterUI
            filterBaseUrl={Urls.indent}
            module="indent_tracking"
            filterField="filters"
            action="filterable_fields"
            extraPayload={{ view: userview ? "user_view" : "company_view" }}
            hiddenFields={[]}
            defaultSortOptions={DEFAULT_SORT_OPTIONS}
            onFilterApply={handleFilterApply}
            onReset={handleFilterReset}
            showViewSelection={allowed_view_indent}
            initialPayload={filterPayload}
            isLoading={isFilterLoading || showloader}
            onClose={() => setfiltershown(false)}
            showSearch={true}
          />
        </div>
      )}

      <div className={`row ${classes["s-row"]} px-3 mb-4`}>
        {!isMobile() ? (
          <div className="w-100" style={{ boxShadow: "3px 3px 3px 3px lightgrey", borderRadius: "4px", overflow: "hidden", border: "1px solid lightgrey" }}>
            <ActiveFilterPills />
            <div className={classes["add-lanes"]} style={{ boxShadow: "none", border: "none", borderTop: isFilterActive ? "1px solid lightgrey" : "none" }}>
              <table className="added_lanes_table">
                <thead style={{ background: "whitesmoke" }}>
                  <tr>
                    {/* <th style={{border:'none', textAlign:'center', width: '5%'}}>Indent Request No</th> */}
                    <th
                      style={{ border: "none", textAlign: "center", width: "5%" }}
                    >
                      User Name
                    </th>
                    <th
                      style={{ border: "none", textAlign: "center", width: "7%" }}
                    >
                      Created On
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        width: "15%",
                      }}
                    >
                      Lane
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        width: "10%",
                      }}
                    >
                      Truck type
                    </th>
                    <th
                      style={{ border: "none", textAlign: "center", width: "7%" }}
                    >
                      Date of placement
                    </th>
                    <th
                      style={{ border: "none", textAlign: "center", width: "7%" }}
                    >
                      Transporter Name
                    </th>
                    <th
                      style={{ border: "none", textAlign: "center", width: "5%" }}
                    >
                      Truck Details
                    </th>
                    {/* <th style={{border:'none', textAlign:'center', width: '7%'}}>Vehicle Details</th> */}
                    <th
                      style={{ border: "none", textAlign: "center", width: "6%" }}
                    >
                      Send Message
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        width: "30%",
                      }}
                    >
                      <div>Truck Status</div>
                      {/* <div>Timeline</div> */}
                      <div>
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          <i
                            className="fa fa-circle"
                            style={{
                              padding: "0 1%",
                              fontSize: "10px",
                              color: "#54af3a",
                            }}
                          ></i>
                          Updated by transporter
                        </span>
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          <i
                            className="fa fa-circle"
                            style={{
                              padding: "0 1%",
                              fontSize: "10px",
                              color: "#393186",
                            }}
                          ></i>
                          Updated by Company
                        </span>
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          <i
                            className="fa fa-circle"
                            style={{
                              padding: "0 1%",
                              fontSize: "10px",
                              color: "#d9534f",
                            }}
                          ></i>
                          Cancelled Indents
                        </span>
                        <br />
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          (Please click on the dot to update status)
                        </span>
                      </div>
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "left",
                        width: "11%",
                      }}
                    >
                      <div>Upload POD/Invoice/LR</div>
                      <div>
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          <i
                            className="fa fa-file-invoice-dollar"
                            style={{
                              padding: "0 5%",
                              fontSize: "15px",
                              color: "#54af3a",
                            }}
                          ></i>
                          Invoice
                        </span>
                        <br />
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          <i
                            className="fa fa-file-invoice"
                            style={{
                              padding: "0 5%",
                              fontSize: "15px",
                              color: "#54af3a",
                            }}
                          ></i>
                          POD
                        </span>
                        <br />
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          <i
                            className="fa fa-file-alt"
                            style={{
                              padding: "0 5%",
                              fontSize: "15px",
                              color: "#54af3a",
                            }}
                          ></i>
                          LR
                        </span>
                      </div>
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        width: "8%",
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {lastupdatelist && lastupdatelist.length > 0 ? (
                    lastupdatelist.map((indent, index) => {
                      return (
                        <tr key={indent.vehicle.indent_id_sub}>
                          {/* <td style={{border:'none'}}>{indent.display_indent_id}</td> */}
                          <td style={{ border: "none" }}>
                            {indent.user_list && indent.user_list.length > 0
                              ? indent.user_list.map((it) => {
                                return titleCase(it.user_email.split("@")[0]);
                              })
                              : null}
                            {/* <div>{indent.vehicle.indent_id_sub}</div> */}
                          </td>
                          <td style={{ border: "none" }}>
                            {indent.created_date}
                          </td>
                          <td
                            style={{
                              border: "none",
                              textAlign: "center",
                              paddingLeft: "0%",
                            }}
                          >
                            <div
                              className={`${classes["lanedata"]} justify-content-center`}
                            >
                              <Popupwidget
                                buttonLabel={
                                  <div className={`d-flex`}>
                                    {/* Cancelled icon */}
                                    {(indent?.vehicle?.status_track?.some(
                                      (s) =>
                                        s.value?.toLowerCase() === "cancelled",
                                    ) ||
                                      indent?.is_cancelled?.status) && (
                                        <span
                                          style={{
                                            fontSize: "14px",
                                            marginRight: "8px",
                                            cursor: "pointer",
                                          }}
                                          data-tip
                                          data-for={`cancelled_icon_lane_tooltip_${index}`}
                                        >
                                          <i
                                            className="fa fa-ban"
                                            style={{ color: "red" }}
                                          />
                                          <ReactTooltip
                                            id={`cancelled_icon_lane_tooltip_${index}`}
                                            place="top"
                                            effect="solid"
                                          >
                                            This indent is cancelled
                                          </ReactTooltip>
                                        </span>
                                      )}
                                    <span
                                      data-tip
                                      data-for={`origin${index}`}
                                      style={{
                                        width: "70%",
                                        display: "flex",
                                        gap: "8px",
                                        alignItems: "center",
                                        padding: "3px 0px",
                                        flexWrap: "nowrap",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {
                                          indent.indent_info.origin.location
                                            .location
                                        }
                                      </span>
                                      <i
                                        className="fa fa-arrow-right"
                                        style={{ padding: "3% 6%" }}
                                      />
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {
                                          indent.indent_info.destination.location
                                            .location
                                        }
                                      </span>
                                    </span>
                                    <ReactTooltip
                                      id={`origin${index}`}
                                      place="bottom"
                                      effect="float"
                                      backgroundColor="#393185 !important"
                                    >
                                      Origin:{" "}
                                      {indent.indent_info.origin.location_name}
                                      <br />
                                      Destination:{" "}
                                      {
                                        indent.indent_info.destination
                                          .location_name
                                      }
                                    </ReactTooltip>
                                  </div>
                                }
                                buttonClass={classes["tripType"]}
                                title="Drop Location Details"
                                content={<TransportType indent={indent} />}
                                size="lg"
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {indent.delay && (
                                <>
                                  <span
                                    data-tip
                                    data-for={`delay${index}`}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className={`fa fa-exclamation-circle ${classes["delay-icon"]}`}
                                      style={{ marginRight: "6px", color: "red" }}
                                    />
                                  </span>
                                  <ReactTooltip
                                    id={`delay${index}`}
                                    className={`${classes["tooltip"]}`}
                                    place="bottom"
                                    effect="float"
                                    backgroundColor="#393185 !important"
                                  >
                                    This indent has been Delayed
                                  </ReactTooltip>
                                </>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "13px",
                                  fontWeight: 450,
                                }}
                              >
                                <span>
                                  Indent ID: {indent.vehicle.indent_id_sub}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "13px",
                                  fontWeight: 450,
                                }}
                              >
                                {indent?.vehicle?.display_lr_number && (
                                  <span>
                                    LR NO:{indent?.vehicle?.display_lr_number}
                                  </span>
                                )}
                              </div>
                              {indent.indent_info.from === "planning" && (
                                <div style={{ marginLeft: "5px" }}>
                                  <i
                                    className="fa fa-calendar-check-o"
                                    style={{
                                      color: "#398531ff",
                                      fontSize: "16px",
                                    }}
                                    data-tip
                                    data-for={`planning${index}`}
                                  />
                                  <ReactTooltip
                                    id={`planning${index}`}
                                    place="bottom"
                                    effect="float"
                                    backgroundColor="#393185 !important"
                                  >
                                    From Planning
                                  </ReactTooltip>
                                </div>
                              )}
                            </div>
                          </td>

                          <td style={{ border: "none" }}>
                            <center>
                              {indent.indent_info.truck_types[0].value}
                              <br />
                              {indent.indent_info.tonnage ||
                                indent.indent_info.capacity ? (
                                <span>
                                  {" "}
                                  <hr /> Weight:{" "}
                                  {indent.indent_info.tonnage
                                    ? indent.indent_info.tonnage
                                    : null}{" "}
                                  {indent.indent_info.capacity
                                    ? indent.indent_info.capacity
                                    : null}
                                </span>
                              ) : null}
                            </center>
                            {indent.vehicle?.truck_details?.vehicle_no && (
                              <div>
                                <span
                                  style={{
                                    color: " #393185",
                                    fontWeight: "bold",
                                    marginTop: "6px",
                                  }}
                                >
                                  {" "}
                                  (
                                  {indent.vehicle?.truck_details?.vehicle_no ||
                                    " "}
                                  )
                                </span>
                              </div>
                            )}
                          </td>
                          <td style={{ border: "none" }}>
                            {indent.indent_info.placement_date}
                          </td>
                          <td style={{ border: "none" }}>
                            <ProfileModal
                              transporter_id={indent.vehicle.transporter_id}
                              transporter_name={indent.vehicle.transporter_name}
                              screenName={"Indent Tracking"}
                              moduleName={"Indents"}
                            />
                          </td>
                          <td style={{ border: "none" }}>
                            <Modal
                              buttonLabel={
                                <>
                                  <span style={{ fontSize: 13 }}>View</span>
                                  <span
                                    data-tip
                                    data-for={`cons_tooltip_${index}`}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i
                                      className={`fa fa-cube mx-2`}
                                      style={{
                                        color: getColor(
                                          indent?.consignment_details_exist,
                                        ),
                                      }}
                                      aria-hidden="true"
                                    />
                                  </span>

                                  <ReactTooltip
                                    id={`cons_tooltip_${index}`}
                                    place="top"
                                    effect="solid"
                                  >
                                    {indent?.consignment_details_exist
                                      ? "Consignment Details Available"
                                      : "Consignment Details Missing"}
                                  </ReactTooltip>
                                </>
                              }
                              buttonClass="btn btn-sm btn-link"
                              content={
                                <ViewDetails
                                  getVehicleTracking={getVehicleTracking}
                                  truck_details={indent.vehicle.truck_details}
                                  indent_id={indent.indent_id}
                                  truck_status={indent?.vehicle?.status_track}
                                  indent_sub_id={indent.vehicle.indent_id_sub}
                                  origin={indent.indent_info.origin}
                                  destination={indent.indent_info.destination}
                                  lr_ids={indent?.vehicle?.lr_ids}
                                  userDefinedFields={
                                    indent?.indent_info?.user_defined_fields
                                  }
                                  isPlanning={
                                    indent.indent_info.from === "planning"
                                  }
                                  isRestricted={isRestricted}
                                  readOnly={indent.vehicle.status_track?.some(
                                    (st) => st.value === "dispatched",
                                  )}
                                />
                              }
                              title={`Truck Details`}
                              id="closebutton"
                              screenName="Indents"
                              moduleName="Indent Tracking"
                              activityName={`Truck Details button clicked for lane ${indent.indent_info.origin.location_name}_TO_${indent.indent_info.destination.location_name}_${indent.indent_info.truck_types[0].value}`}
                              backdrop={false}
                              style={{ fontSize: "13px" }}
                              size="xl"
                              dialogClassName="modal-90w"
                            />
                            <br />
                            {/* <div
                            className={`text-capitalize ${classes["badge"]
                              } ${getStatusStyle(
                                indent?.vehicle?.invoice_status
                              )}`}
                          >
                            {indent?.vehicle?.invoice_status ? (
                              <>
                                {`${indent?.vehicle?.invoice_status ===
                                  "clarity_needed"
                                  ? "Clarity Needed for Invoice"
                                  : indent?.vehicle?.invoice_status ===
                                    "not_generated"
                                    ? "Invoice Not Generated"
                                    : indent?.vehicle?.invoice_status ===
                                      "onhold"
                                      ? " Invoice Approval On Hold"
                                      : indent?.vehicle?.invoice_status ===
                                        "pending"
                                        ? "Invoice Approval Pending"
                                        : indent?.vehicle?.invoice_status
                                  }`}
                              </>
                            ) : null}
                          </div> */}
                          </td>
                          <td style={{ border: "none" }}>
                            <div>
                              <Modal
                                style={{}}
                                buttonLabel={
                                  <>
                                    <i
                                      style={{
                                        color: "white",
                                        marginRight: "3px",
                                      }}
                                      data-tip
                                      data-for="comment_button"
                                      className="fa fa-comments-o"
                                    ></i>
                                    <ReactTooltip
                                      id="comment_button"
                                      place="bottom"
                                      effect="float"
                                      backgroundColor="#393185!important"
                                    >
                                      Chat
                                    </ReactTooltip>
                                    {indent.noofenq ? indent.noofenq : null}
                                  </>
                                }
                                buttonClass={
                                  indent.no_of_enq && indent.no_of_enq > 0
                                    ? "btn btn-sm btn-success"
                                    : "btn btn-sm btn-primary"
                                }
                                content={
                                  <ViewEnquiry
                                    item={indent}
                                    transporter_list={
                                      indent.indent_info.shortlisted_transporters
                                    }
                                    id={indent.indent_id}
                                    type={"indent"}
                                    screenName={"Indents"}
                                    moduleName={"Indent Tracking"}
                                  />
                                }
                                title="LoRRI Chat"
                                subtitle={
                                  <span>
                                    {indent.indent_info.origin.location_name} to{" "}
                                    {indent.indent_info.destination.location_name}{" "}
                                    -{" "}
                                    {Array.isArray(indent.indent_info.truck_types)
                                      ? indent.indent_info.truck_types
                                        .map((truck) => truck.label)
                                        .join(", ")
                                      : indent.indent_info.truck_types.label}
                                  </span>
                                }
                                onClose={closechatModal}
                                size="2xl"
                                id="editenquiry"
                                screenName="Indents"
                                showLogo={true}
                                moduleName="Indent Tracking"
                                activityName={`Chat button clicked for lane ${indent.indent_info.origin.location_name}_TO_${indent.indent_info.destination.location_name}_${indent.indent_info.truck_types[0].value}`}
                                backdrop={true}
                                className={classes["chat-modal"]}
                                disabled={isRestricted}
                              />
                            </div>
                          </td>
                          {/* <td style={{border:'none'}}>{getStepper(indent)}</td> */}
                          <td style={{ border: "none" }}>
                            <Timeline
                              status_track={indent.vehicle.status_track}
                              indent_id={indent.indent_id}
                              indent_id_sub={indent.vehicle.indent_id_sub}
                              show={showloader}
                              index={index}
                              transporter_id={indent.vehicle.transporter_id}
                              setShow={setShowloader}
                              getData={getData}
                              isAccountant={isAccountant}
                              checkPresentInvoice={checkPresentInvoice}
                              indent={indent}
                              isRestricted={isRestricted}
                            />
                          </td>
                          <td style={{ border: "none", textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                              }}
                            >
                              <div style={{ display: "flex", gap: "8px" }}>
                                <i
                                  className="fa fa-file-invoice-dollar"
                                  style={{
                                    color: checkPresent(indent, "invoice"),
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                  data-tip
                                  data-for={checkPresentInvoice(
                                    indent,
                                    "invoice",
                                  )}
                                />

                                <i
                                  className="fa fa-file-invoice"
                                  style={{
                                    color: checkPresent(indent, "pod"),
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                  data-tip
                                  data-for={checkPresentPOD(indent, "pod")}
                                />

                                <i
                                  className="fa fa-file-alt" // Assuming this is the icon for LR
                                  style={{
                                    color: indent.lr_uploaded ? "#54a63a" : "red", // Check if LR is uploaded, if yes, color green, else red
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                  data-tip
                                  data-for={
                                    indent.lr_uploaded
                                      ? "LR_uploaded"
                                      : "LR_not_Uploaded"
                                  }
                                />
                              </div>
                              <ReactTooltip
                                id="uploaded_invoice"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <div>Invoice Uploaded</div>
                              </ReactTooltip>
                              <ReactTooltip
                                id="not_uploaded_invoice"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <div>Invoice not uploaded</div>
                              </ReactTooltip>
                              <ReactTooltip
                                id="uploaded_pod"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <div>Proof of Delivery Uploaded</div>
                              </ReactTooltip>
                              <ReactTooltip
                                id="not_uploaded_pod"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <div>Proof of Delivery not uploaded</div>
                              </ReactTooltip>
                              <ReactTooltip
                                id="LR_uploaded"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <div>LR Uploaded</div>
                              </ReactTooltip>

                              <ReactTooltip
                                id="LR_not_Uploaded"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <div>LR Not Uploaded</div>
                              </ReactTooltip>

                              <span
                                data-tip
                                data-for={`upload_action_tooltip_${index}`}
                              >
                                <Modal
                                  style={{}}
                                  buttonLabel={
                                    <div
                                      style={{
                                        backgroundColor: "#393185",
                                        borderRadius: "6px",
                                        width: "29px",
                                        height: "29px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: isRestricted
                                          ? "not-allowed"
                                          : "pointer",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      <i
                                        className="fa fa-upload"
                                        style={{
                                          fontSize: "12px",
                                          color: "white",
                                        }}
                                      />
                                    </div>
                                  }
                                  buttonClass="btn btn-link p-0"
                                  content={
                                    <UploadPOD
                                      indent={indent}
                                      getVehicleTracking={getVehicleTracking}
                                      skipactive={skipactive}
                                      sendMail1={sendMail1}
                                      getData={getData}
                                    />
                                  }
                                  title={`Upload or Download POD/Invoice`}
                                  id="closebutton"
                                  screenName="Indents"
                                  moduleName="Indent Tracking"
                                  activityName="POD/ Invoice Upload Button Clicked"
                                  backdrop={false}
                                  onClose={getData}
                                  disabled={isRestricted}
                                />
                              </span>
                              <ReactTooltip
                                id={`upload_action_tooltip_${index}`}
                                place="left"
                                effect="solid"
                                backgroundColor="#393185 !important"
                              >
                                Upload documents
                              </ReactTooltip>

                              {(userDetails?.policy?.indents?.track_and_trace
                                ?.allowed === "yes" ||
                                userDetails?.policy?.indents
                                  ?.allowed_sim_tracking === "yes") && (
                                  <div>
                                    <button
                                      onClick={() =>
                                        window.open(
                                          TRACKING_DETAILS_URL(indent?.indent_id, indent?.vehicle?.indent_id_sub),
                                          "_blank",
                                        )
                                      }
                                      disabled={
                                        indent?.vehicle?.status_track?.length < 2 ||
                                        indent?.is_cancelled?.status
                                      }
                                      className="btn btn-success btn-sm"
                                      style={{
                                        fontSize: "13px",
                                        padding: "2px 8px",
                                      }}
                                    >
                                      <i className="fa fa-map-marker mr-1" />
                                      Track
                                    </button>
                                  </div>
                                )}
                            </div>
                          </td>
                          <td style={{ border: "none", textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "15px",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "5px 0",
                              }}
                            >
                              {/* Cancel Button */}
                              {indent &&
                                indent.vehicle &&
                                indent.vehicle.status_track &&
                                indent.vehicle.status_track.some(
                                  (s) => s.value?.toLowerCase() === "cancelled",
                                ) ? (
                                <>
                                  <span
                                    data-tip
                                    data-for={`cancelled_status_tooltip_${index}`}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "6px",
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "default",
                                        border: "1px solid #dee2e6",
                                      }}
                                    >
                                      <i
                                        className="fa fa-ban"
                                        style={{ color: "red", fontSize: "14px" }}
                                      />
                                    </div>
                                  </span>
                                  <ReactTooltip
                                    id={`cancelled_status_tooltip_${index}`}
                                    place="left"
                                    effect="solid"
                                    backgroundColor="#393185 !important"
                                  >
                                    Cancelled
                                  </ReactTooltip>
                                </>
                              ) : (
                                !indent.vehicle.status_track.some(s => s.value?.toLowerCase() === 'dispatched') ? (
                                  <>
                                    <span
                                      data-tip
                                      data-for={`cancel_action_tooltip_${index}`}
                                    >
                                      <Modal
                                        style={{}}
                                        buttonLabel={
                                          <div style={{
                                            backgroundColor: '#393185',
                                            borderRadius: '6px',
                                            width: '28px',
                                            height: '28px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: isRestricted ? 'not-allowed' : 'pointer',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                          }}>
                                            <i className="fa fa-times" style={{ fontSize: '14px', color: 'white' }}></i>
                                          </div>
                                        }
                                        buttonClass="btn btn-link p-0"
                                        content={
                                          <CancelIndent
                                            indent_id={indent.indent_id}
                                            indent_id_sub={indent.vehicle.indent_id_sub}
                                            getData={getData}
                                            onClose={getData}
                                            companySettingData={companySettingData}
                                            userDetails={userDetails}
                                          />
                                        }
                                        title="Cancel Indent"
                                        id="cancel_indent_modal"
                                        backdrop={false}
                                        onClose={getData}
                                        disabled={isRestricted}
                                      />
                                    </span>
                                    <ReactTooltip
                                      id={`cancel_action_tooltip_${index}`}
                                      place="left"
                                      effect="solid"
                                      backgroundColor="#393185 !important"
                                    >
                                      Cancel indent
                                    </ReactTooltip>
                                  </>
                                ) : (
                                  <>
                                    <span data-tip data-for={`cancel_disabled_tooltip_${index}`}>
                                      <div style={{
                                        backgroundColor: '#e9ecef',
                                        borderRadius: '6px',
                                        width: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'not-allowed',
                                      }}>
                                        <i className="fa fa-times" style={{ fontSize: '14px', color: '#adb5bd' }} />
                                      </div>
                                    </span>
                                    <ReactTooltip
                                      id={`cancel_disabled_tooltip_${index}`}
                                      place="left"
                                      effect="solid"
                                      backgroundColor="#393185 !important"
                                    >
                                      Cancel Indent
                                    </ReactTooltip>
                                  </>
                                )
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="11" rowSpan="6" style={{ height: "200px" }}>
                        <span
                          style={{ fontSize: "x-large", fontStyle: "italic" }}
                        >
                          No Results Found
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : lastupdatelist && lastupdatelist.length > 0 ? (
          lastupdatelist.map((indent, index) => {
            return (
              <div
                className={`${classes["mobile-enquiry"]} ${indent.delay ? classes["highlight-delay"] : ""
                  }`}
              >
                <div
                  style={{
                    display: "flex",
                    padding: "2%",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {indent.delay && (
                      <>
                        <span
                          data-tip
                          data-for={`delay_mobile${index}`}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <i
                            className={`fa fa-exclamation-circle ${classes["delay-icon"]}`}
                            style={{ marginRight: "6px", color: "red" }}
                          />
                        </span>
                        <ReactTooltip
                          id={`delay_mobile${index}`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          This indent has been Delayed
                        </ReactTooltip>
                      </>
                    )}
                    <b>Indent ID : </b>
                    {indent.vehicle.indent_id_sub
                      ? indent.vehicle.indent_id_sub
                      : "NA"}
                  </span>
                  <span style={{ fontSize: "13px", display: "flex" }}>
                    <b>User Name : </b>
                    {indent.user_list && indent.user_list.length > 0
                      ? indent.user_list.map((it) => {
                        return titleCase(it.user_email.split("@")[0]);
                      })
                      : null}
                  </span>
                </div>
                <div style={{ padding: "2%" }}>
                  <div style={{ fontSize: "13px" }}>
                    <b>Created On : </b>
                    {indent.created_date ? indent.created_date : "NA"}
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      display: "flex",
                      justifyContent: "flex-end",
                      fontWeight: "600",
                      width: "125px",
                    }}
                  >
                    <i
                      className="fa fa-map-marker"
                      style={{
                        color: "#393186",
                        marginRight: "6%",
                        marginTop: "2%",
                      }}
                    />
                    <span
                      style={{ cursor: "pointer" }}
                      data-tip
                      data-for={`origin${index}`}
                    >
                      {indent.indent_info &&
                        indent.indent_info.origin.location.location
                        ? indent.indent_info.origin.location.location
                        : "NA"}
                    </span>
                    <ReactTooltip
                      id={`origin${index}`}
                      className={`${classes["tooltip"]}`}
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      {indent.indent_info.origin.location_name}
                    </ReactTooltip>
                  </div>
                  <i
                    className={`fa fa-arrow-right`}
                    style={{ marginTop: "1%" }}
                  />
                  <div
                    style={{
                      fontSize: "16px",
                      display: "flex",
                      width: "125px",
                      fontWeight: "600",
                    }}
                  >
                    <i
                      className="fa fa-map-marker"
                      style={{
                        color: "#393186",
                        marginRight: "6%",
                        marginTop: "2%",
                      }}
                    />
                    <span
                      style={{ cursor: "pointer" }}
                      data-tip
                      data-for={`origin${index}`}
                    >
                      {indent.indent_info &&
                        indent.indent_info.destination.location.location
                        ? indent.indent_info.destination.location.location
                        : "NA"}
                    </span>
                    <ReactTooltip
                      id={`origin${index}`}
                      className={`${classes["tooltip"]}`}
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      {indent.indent_info.destination.location_name}
                    </ReactTooltip>
                  </div>
                </div>
                <div style={{ fontSize: "14px", textAlign: "center" }}>
                  {indent.indent_info.truck_types[0].value}
                </div>
                <div style={{ padding: "2%", paddingTop: "2%" }}>
                  <div
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      paddingBottom: "2%",
                    }}
                  >
                    <b style={{ width: "40%" }}>Date of Placement : </b>
                    {indent.indent_info.placement_date
                      ? indent.indent_info.placement_date
                      : "NA"}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      paddingBottom: "2%",
                    }}
                  >
                    <b style={{ width: "56%", paddingTop: "2%" }}>
                      Transporter Name :{" "}
                    </b>
                    <ProfileModal
                      transporter_id={indent.vehicle.transporter_id}
                      transporter_name={indent.vehicle.transporter_name}
                      screenName={"Indent Tracking"}
                      moduleName={"Indents"}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      paddingBottom: "2%",
                    }}
                  >
                    <b style={{ paddingTop: "1%", width: "37%" }}>
                      Truck Details :{" "}
                    </b>
                    <Modal
                      buttonLabel={
                        <>
                          <span style={{ fontSize: "13px" }}>View</span>
                          {indent.vehicle.truck_details &&
                            indent.vehicle.truck_details.vehicle_no ? (
                            <i
                              className="fa fa-circle"
                              style={{
                                marginLeft: "3px",
                                color: "#54AF3A",
                                fontSize: "10px",
                              }}
                            />
                          ) : null}
                        </>
                      }
                      buttonClass="btn btn-sm btn-link"
                      content={
                        <ViewDetails
                          getVehicleTracking={getVehicleTracking}
                          truck_details={indent.vehicle.truck_details}
                          indent_id={indent.indent_id}
                          indent_sub_id={indent.vehicle.indent_id_sub}
                          origin={indent.indent_info.origin}
                          destination={indent.indent_info.destination}
                          lr_ids={indent?.vehicle?.lr_ids}
                          userDefinedFields={
                            indent?.indent_info?.user_defined_fields
                          }
                          isPlanning={indent.indent_info.from === "planning"}
                          readOnly={indent.vehicle.status_track?.some(
                            (st) => st.value === "dispatched",
                          )}
                        />
                      }
                      title={`Truck Details`}
                      id="closebutton"
                      screenName="Indents"
                      moduleName="Indent Tracking"
                      activityName={`Truck Details button clicked for lane ${indent.indent_info.origin.location_name}_TO_${indent.indent_info.destination.location_name}_${indent.indent_info.truck_types[0].value}`}
                      backdrop={false}
                      style={{ fontSize: "14px" }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      paddingBottom: "2%",
                    }}
                  >
                    <b style={{ width: "40%" }}>Send Message : </b>
                    <Modal
                      buttonLabel={
                        <>
                          <i
                            style={{ color: "white", marginRight: "3px" }}
                            className="fa fa-comments-o"
                          />
                          {indent.noofenq ? indent.noofenq : null}
                        </>
                      }
                      buttonClass={
                        indent.no_of_enq && indent.no_of_enq > 0
                          ? "btn btn-sm btn-success"
                          : "btn btn-sm btn-primary"
                      }
                      content={
                        <ViewEnquiry
                          item={indent}
                          transporter_list={
                            indent.indent_info.shortlisted_transporters
                          }
                          id={indent.indent_id}
                          type={"indent"}
                          screenName={"Indents"}
                          moduleName={"Indent Tracking"}
                        />
                      }
                      title="LoRRI Chat"
                      subtitle={
                        <span>
                          {indent.indent_info.origin.location_name} to{" "}
                          {indent.indent_info.destination.location_name} -{" "}
                          {Array.isArray(indent.indent_info.truck_types)
                            ? indent.indent_info.truck_types
                              .map((truck) => truck.label)
                              .join(", ")
                            : indent.indent_info.truck_types.label}
                        </span>
                      }
                      onClose={closechatModal}
                      id="editenquiry"
                      size="lg"
                      screenName="Indents"
                      moduleName="Indent Tracking"
                      activityName={`Chat button clicked for lane ${indent.indent_info.origin.location_name}_TO_${indent.indent_info.destination.location_name}_${indent.indent_info.truck_types[0].value}`}
                      backdrop={true}
                      className={classes["chat-modal"]}
                    />
                  </div>
                  <div style={{ fontSize: "14px", paddingBottom: "2%" }}>
                    <b>Truck Status : </b>
                    <br />
                    <Timeline
                      status_track={indent.vehicle.status_track}
                      indent_id={indent.indent_id}
                      indent_id_sub={indent.vehicle.indent_id_sub}
                      show={showloader}
                      index={index}
                      transporter_id={indent.vehicle.transporter_id}
                      setShow={setShowloader}
                      getData={getData}
                      isAccountant={isAccountant}
                      checkPresentInvoice={checkPresentInvoice}
                      indent={indent}
                      isRestricted={isRestricted}
                    />
                  </div>
                  <div style={{ fontSize: "14px", paddingBottom: "2%" }}>
                    <b>Upload POD / Invoice : </b>
                    <Modal
                      buttonLabel={
                        <i
                          className="fa fa-upload"
                          style={{ color: "white" }}
                        />
                      }
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <UploadPOD
                          indent={indent}
                          getVehicleTracking={getVehicleTracking}
                          skipactive={skipactive}
                          sendMail1={sendMail1}
                          getData={getData}
                        />
                      }
                      title={`Upload or Download POD/Invoice`}
                      id="closebutton"
                      screenName="Indents"
                      moduleName="Indent Tracking"
                      activityName="POD/ Invoice Upload Button Clicked"
                      backdrop={false}
                      style={{ fontSize: "14px" }}
                      onClose={getData}
                    />
                    <br />
                    {/* Cancel Button Logic for Mobile */}
                    <div style={{ marginBottom: "10px" }}>
                      {indent &&
                        indent.vehicle &&
                        indent.vehicle.status_track &&
                        indent.vehicle.status_track.some(
                          (s) => s.value?.toLowerCase() === "cancelled",
                        ) ? (
                        <>
                          <span
                            className="badge badge-danger"
                            style={{
                              fontSize: "12px",
                              padding: "8px",
                              cursor: "pointer",
                            }}
                            data-tip
                            data-for={`cancelled_tooltip_mobile_${index}`}
                          >
                            Cancelled
                          </span>
                          <ReactTooltip
                            id={`cancelled_tooltip_mobile_${index}`}
                            place="top"
                            effect="solid"
                          >
                            This indent has been cancelled
                          </ReactTooltip>
                        </>
                      ) : (
                        <div>
                          {indent &&
                            indent.vehicle &&
                            indent.vehicle.status_track &&
                            !indent.vehicle.status_track.some(
                              (s) => s.value?.toLowerCase() === "dispatched",
                            ) ? (
                            <Modal
                              buttonLabel={<i className="fa fa-times" style={{ color: "white" }}></i>}
                              buttonClass="btn btn-sm btn-danger"
                              content={
                                <CancelIndent
                                  indent_id={indent.indent_id}
                                  indent_id_sub={indent.vehicle.indent_id_sub}
                                  getData={getData}
                                />
                              }
                              title="Cancel Indent"
                              id="cancel_indent_modal_mobile"
                              screenName="Indents"
                              moduleName="Indent Tracking"
                              activityName="Cancel Indent Button Clicked (Mobile)"
                              backdrop={false}
                              style={{ fontSize: "14px" }}
                              onClose={getData}
                            />
                          ) : (
                            <button
                              className="btn btn-danger btn-sm"
                              disabled
                              style={{ cursor: "not-allowed", opacity: 0.6 }}
                            >
                              <i
                                className="fa fa-times"
                                style={{ color: "white" }}
                              ></i>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                    <br />
                    <i
                      className="fa fa-file-invoice-dollar"
                      style={{
                        color: checkPresent(indent, "invoice"),
                        fontSize: "24px",
                        cursor: "pointer",
                      }}
                      data-tip
                      data-for={checkPresentInvoice(indent, "invoice")}
                    />
                    <i
                      className="fa fa-file-invoice"
                      style={{
                        color: checkPresent(indent, "pod"),
                        paddingLeft: "10%",
                        fontSize: "25px",
                        cursor: "pointer",
                      }}
                      data-tip
                      data-for={checkPresentPOD(indent, "pod")}
                    />
                    {/* <ReactTooltip
                      id="uploaded_invoice"
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      <div>Invoice Uploaded</div>
                    </ReactTooltip>
                    <ReactTooltip
                      id="not_uploaded_invoice"
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      <div>Invoice not uploaded</div>
                    </ReactTooltip>
                    <ReactTooltip
                      id="uploaded_pod"
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      <div>Proof of Delivery Uploaded</div>
                    </ReactTooltip>
                    <ReactTooltip
                      id="not_uploaded_pod"
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      <div>Proof of Delivery not uploaded</div>
                    </ReactTooltip> */}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <span style={{ fontSize: "x-large", fontStyle: "italic" }}>
            No Results Found
          </span>
        )}
        <center style={{ width: "100%" }}>
          <Pagination
            activePage={skipactive + 1}
            itemsCountPerPage={filterPayload?.pagination?.limit || 10}
            totalItemsCount={totalindents}
            onChange={(e) => getOnChange(e)}
            itemClass="page-item"
            linkClass="page-link"
            hideDisabled
          />
        </center>
        <ExcelFileTable
          ExcelDownloadIndents={ExcelDownloadIndents}
          setExcelDownloadIndents={setExcelDownloadIndents}
        />
      </div>
    </div>
  );
};

export default Indenttrack;
